// Foundations
import {Component, Input, OnInit} from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';

// Services
import { AnalyticsService } from 'src/app/services/analytics.service';
import {RemovePetGQL} from '../../../services/graphql.service';
import {MatSnackBar} from '@angular/material/snack-bar';

enum SurveyOptions {
  NO_LONGER_ATTENDING,
  DECEASED,
}

@Component({
  selector: 'app-dog-removed-survey',
  templateUrl: './dog-removed-survey.component.html',
  styleUrls: ['./dog-removed-survey.component.scss']
})
export class DogRemovedSurveyComponent implements OnInit {

  @Input() petId: number;
  @Input() petName: string;
  surveyOptions = SurveyOptions;

  form: FormGroup;

  isDeceased = true;
  showMessage = false;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private _analytics: AnalyticsService,
    private removePetGQL: RemovePetGQL,
    private snackBar: MatSnackBar
  ) {
    this.form = this.fb.group({
      survey: ['', Validators.required],
      reasonMsg: '',
      deceasedMsg: ''
    });
  }

  ngOnInit(): void {
  }

  // Public Methods
  // ------------------------------------------------------------------------------------

  get f(): any {
    return this.form.controls;
  }

  navigateToLandingPage(): void {
    this._analytics.logButtonTap('dogProfile_returnFromRemoveCamperSurvey');
    this.router.navigate(['/']);
  }

  onSubmit(): void {
    this._analytics.logButtonTap('dogProfile_submitRemoveCamperSurvey');
    this.showMessage = true;

    if (this.form.get('survey').value === SurveyOptions.NO_LONGER_ATTENDING) {
      this.isDeceased = false;
    }
    this.removePetGQL.mutate({
      petId: this.petId.toString(),
      petRemoval: {
        deceased: this.isDeceased,
        notes: this.isDeceased ? this.form.get('deceasedMsg').value : this.form.get('reasonMsg').value
      }
    }).subscribe(result => {
      if (result.errors){
        this.snackBar.open(result.errors[0].message, '', { duration: 2000 });
      }
    });
  }
}
